<template>
    <div class="standardCourseCard" @click="goto(data.innerid)">
        <div class="img">
            <img v-lazy="data.coverurl" :alt="data.subject">
        </div>
        <div class="text">
            <p class="title">{{data.subject}}</p>
            <div class="box">
                <span class="text_money" v-if="data.feetype == 2">￥{{data.saleprice}}</span>
                <span class="text_money" v-else>免费</span>
                <!--<span class="text_participant">{{data.joincount}}人参与</span>-->
                <span class="limit-box" v-if="data.islimitcount">限时折扣</span>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "standardCourseCard",
    props: ['data'],
    mounted() {
    },
    methods: {
      goto(id) {
        // 判断是课程还是题库 7课程 8题库
        if (this.data.kmctype == 8) {
          const {href} = this.$router.resolve({
            name: "QuestionDetails",
            query: {
              qid: id
            }
          })
          window.open(href, '_blank');
        } else if (this.data.kmctype == 7) {
          const {href} = this.$router.resolve({
            name: "CourseDetails",
            query: {
              cid: id,
              chid: this.channelid
            }
          })
          window.open(href, '_blank');
        } else {
          const {href} = this.$router.resolve({
            name: "ReportDetails",
            query: {
              reportid: id
            }
          })
          window.open(href, '_blank');
        }

        // this.$router.push({name: 'CourseDetails', query: {'cid': id}})
      }
    },
    computed: {
      ...mapGetters([
        'channelid'
      ])
    }
  }
</script>
<style lang="scss" type="text/scss">
    .standardCourseCard {
        float: left;
        margin-bottom: 20px;
        margin-right: 12px;
        width: 226px;
        height: 236px;
        border-radius: 6px;
        cursor: pointer;
        transition: all .5s;
        -moz-transition: all .5s;
        -o-transition: all .5s;
        -ms-transition: all .5s;
        -webkit-transition: all .5s;
        .limit-box{
            width: 64px;
            height: 20px;
            border-radius: 4px;
            border: 1px solid #FF4747;
            color: #FF4747;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
        }
        .img {
            width: 226px;
            height: 128px;
            transition: all .5s;
            -moz-transition: all .5s;
            -o-transition: all .5s;
            -ms-transition: all .5s;
            -webkit-transition: all .5s;
            border-radius: 6px;
            background: #E5E5E5;

            img {
                width: 100%;
                height: 100%;
                border-radius: 6px;

            }
        }
        .title {
            min-height: 42px;
            margin: 10px auto;
            font-size: 16px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 21px;
            word-break: break-all;
        }
        &:hover {
            transition: all .5s;
            -moz-transition: all .5s;
            -o-transition: all .5s;
            -ms-transition: all .5s;
            -webkit-transition: all .5s;
            box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
            -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
            -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
            -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
            -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
        }
        .text {
            padding: 0 4px 0 4px;
            box-sizing: border-box;
            .box{
                display: flex;
                align-items: center;
            }
        }
        .text_money, .text_participant {
            font-size: 14px;
        }
        .text_money {
            margin-right: 12px;
            color: #FF4747
        }
        .text_participant {
            color: #999;
        }
    }
</style>